import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";


export type RoleMappingJson =
    {
        "result": {
            "id": number,
            "role": string,
            "description": string | null,
            "code": string,
            "isDeleted": boolean,

        },
        "statusCode": "fetch-role-success-002",
        "message": "Role data fetched successfully",
        "success": true
    }

export type RoleType =
    {
        "id": number,
        "role": string,
        "description": string | null,
        "code": string,
        "isDeleted": boolean

    }

export type CommonField =
    {
        error: string | null
    }


export type locationJson =
    {
        "locations": {
            "count": number,
            "rows": locationType[]
        }
    }

export type locationType =
    {
        "id": number,
        "locationName": string,
        "isGlobal": boolean,
        "allowedZipcodes": string | null,
        "orderAmountLimit": number,
        "isDefault": boolean
    }

export type sendPosStaffPayload =
    {
        clientId: string | null,
        emails: string[],
        locationId: number[],
        role: { id: number, role: string, description: string | null, code: string, isDeleted: boolean } | null
    }

export type checkEmail =
    {
        "emailExists": boolean,
        "code": string,
        "message": string,
        "success": boolean
    }

export type sendInvitation =
    {
        "createInvitation": boolean,
        "success": boolean
    }

interface intialStates {
    getOneRoles: CommonField & { value: RoleMappingJson | null },
    getOneLocationMapping: CommonField & { value: locationJson | null }
    sendEmail: CommonField & { value: null | any },
    emailCheck: CommonField & { value: null | any }
}

const intialState: intialStates =
{
    getOneRoles: { error: '', value: null },
    getOneLocationMapping: { error: '', value: null },
    sendEmail: { error: '', value: null },
    emailCheck: { error: '', value: null }
}

export const getOneRoleMapping = createAsyncThunk('inviteStaff/getOneRoleMapping', ({ storeId, id, data }: { storeId: number, id: number, data: { isMapping: boolean } }) => {
    const url = HttpRoutingService.replaceUrl(API.getOnePosRole, { storeId: storeId, id: id })
    return HttpRoutingService.getMethod<RoleMappingJson>(url, data, 'v1/')
})

export const getOneRoleLocation = createAsyncThunk('inviteStaff/getOneRoleLocation', ({ storeId, data }: { storeId: number, data: { isForUser: boolean } }) => {
    const url = HttpRoutingService.replaceUrl(API.sendLocation, { storeId: storeId })
    return HttpRoutingService.getMethod<locationJson>(url, data, "v1/")
})

export const sendPosStaff = createAsyncThunk('inviteStaff/sendPosStaff', ({ storeId, data }: { storeId: number, data: sendPosStaffPayload }) => {
    const url = HttpRoutingService.replaceUrl(API.sendEmail, { storeId: storeId })
    return HttpRoutingService.postMethod<sendInvitation>(url, data, {}, "v2/")
})

export const invitationCheck = createAsyncThunk('inviteStaff/invitationCheck', ({ storeId, data }: { storeId: number, data: { email: string } }) => {
    const url = HttpRoutingService.replaceUrl(API.checkEmail, { storeId: storeId })
    return HttpRoutingService.postMethod<checkEmail>(url, data, {}, "v1/")
})


export const invitedStaffRoleSlice = createSlice({
    initialState: intialState,
    name: "inviteStaff",
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getOneRoleMapping.fulfilled, (state, action) => {
                state.getOneRoles.value = action.payload
            })
            .addCase(getOneRoleMapping.rejected, (state, action) => {
                state.getOneRoles.error = action.error.message as string
            })

            .addCase(getOneRoleLocation.fulfilled, (state, action) => {
                state.getOneLocationMapping.value = action.payload
            })
            .addCase(getOneRoleLocation.rejected, (state, action) => {
                state.getOneLocationMapping.error = action.error.message as string
            })

            .addCase(sendPosStaff.fulfilled, (state, action) => {
                state.sendEmail.value = action.payload
            })
            .addCase(sendPosStaff.rejected, (state, action) => {
                state.sendEmail.error = action.error.message as string
            })



    },
})

export default invitedStaffRoleSlice.reducer